import _createValidator from './createValidator';
export { and, or } from './combinators';
export { optional } from './util';
export { array, empty, string, func, number } from './matchers';
var createValidator = process.env.NODE_ENV === 'production' ? function (x) {
  return function (x) {};
} : _createValidator;
export { createValidator };